export enum OrganizationalTypes {
  Global=0,
  Client=1
}
